<template>
    <page :busy="busy" :tabs="tabs">
        <b-container v-if="userIsOwner !== undefined" fluid>
            <file-manager :features="features" :read-only="userIsOwner"></file-manager>
        </b-container>
    </page>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import Page from '../../generic/page/page.vue';
import OwnerDocumentsFrame from '../common/owner-documents-frame.vue';
import { mapGetters } from 'vuex';

const FileManager = defineAsyncComponent(() =>
    import(
        /* webpackChunkName: "lx-vue-file-manager" */
        '../../generic/file-manager/file-manager.vue'
    )
);

export default {
    name: 'OwnerEdit',
    components: {
        Page,
        OwnerDocumentsFrame,
        FileManager,
    },
    computed: {
        ...mapGetters('header', ['userIsOwner']),
        ownerID() {
            return parseInt(this.$route.params.id);
        },
        tabs() {
            return [
                {
                    title: `Documents`,
                    route: `/app/owner/${this.ownerID}/documents/`,
                    active: true,
                },
            ];
        },
        features() {
            return this.userIsOwner ? ['download', 'preview', 'upload', 'delete'] : null;
        },
    },
    data() {
        return {
            busy: false,
        };
    },
    methods: {
        documentsFrameLoaded() {
            this.busy = false;
        },
    },
};
</script>
